import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Breadcrumb, Grid, Table} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import LineChartCurrency from '../../components/charts/LineChartCurrency';
import FilterBar from '../../components/reports/FilterBar';
import AlertUpgrade from "../../components/extras/AlertUpgrade";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";

class ReportSale extends Component {

    constructor() {
        super();
        this.loadData = this.loadData.bind(this);
    }

    loadData(branch_office, date) {
        if(!localDB.checkPlanAccessExclude('reports_view_all')){
            this.refs.sales_day_chart.loadData(branch_office, 'd', date);
            this.refs.sales_week_chart.loadData(branch_office, 'w', date);
            this.refs.sales_month_chart.loadData(branch_office, 'm', date);
            this.refs.sales_montly_chart.loadData(branch_office, 'my', date);
            this.refs.sales_year_chart.loadData(branch_office, 'y', date);
        }else {
            this.refs.alert_upgrade.open();
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Gráficos de Ventas - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Gráficos de Ventas</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {!localDB.checkPlanAccessExclude('reports_view_all') ? <Table>
                    <FilterBar title='Gráficos de Ventas' callbackGetFilter={this.loadData}/>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell width={16}>
                                <br/>
                                <Grid stackable textAlign='center'>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            id='sales_day_chart'
                                            title='Ventas Diarias'
                                            ref='sales_day_chart'
                                            type='sales'
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            title='Ventas Semanales'
                                            id='sales_week_chart'
                                            ref='sales_week_chart'
                                            type='sales'
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            title='Ventas Mensuales'
                                            id='sales_month_chart'
                                            ref='sales_month_chart'
                                            type='sales'
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            title='Ventas Anuales'
                                            id='sales_montly_chart'
                                            ref='sales_montly_chart'
                                            type='sales'
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            title='Ventas desde el origen de los tiempos'
                                            id='sales_year_chart'
                                            ref='sales_year_chart'
                                            type='sales'
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>:<UpgradeAccount/>}
                <AlertUpgrade ref='alert_upgrade' />
            </div>
        );
    }
}

export default ReportSale;



// WEBPACK FOOTER //
// ./src/containers/reports/ReportSales.js